<div class="template-generator-static">
  <div class="component-controls">
    <label for="component-select">Available Components: </label>
    <select
      id="component-select"
      [(ngModel)]="selectedCustomComponentStaticName"
    >
      @for (comp of parentComponent.availableComponents | keyvalue; track comp)
      {
      <option [value]="comp.value.name">{{ comp.value.name }}</option>
      }
    </select>
    <button
      mat-flat-button
      (click)="
        parentComponent.addComponentToTemplate(
          selectedCustomComponentStaticName,
          parentComponent.getSelectedTemplate(
            parentComponent.selectedCustomTemplatesStaticUUID
          ),
          this.mode
        )
      "
    >
      Add Component
    </button>
  </div>
  <div class="static-gridster-container">
    <div class="preview-wrapper screen-mode-{{ mode }}">
      <div class="preview-container">
        @if (parentComponent.dataLoaded) { @if
        (parentComponent.selectedCustomTemplatesStaticUUID) {
        <gridster
          [options]="parentComponent.gridOptions"
          (gridsterItemInitialized)="
            parentComponent.onGridsterStaticComponentReady(this.mode, $event)
          "
        >
          @for (item of
          parentComponent.getSelectedTemplateComponents(parentComponent.selectedCustomTemplatesStaticUUID,
          this.mode); track item) {
          <gridster-item [item]="item">
            <div class="grid-item">
              <button
                id="edit_button"
                (click)="
                  parentComponent.editComponentFromGridster(
                    item.uuid!,
                    parentComponent.selectedCustomTemplatesStaticUUID
                  )
                "
              >
                E
              </button>
              <button
                id="copy_button"
                (click)="
                  parentComponent.copyComponentInTemplate(
                    item,
                    parentComponent.selectedCustomTemplatesStaticUUID
                  )
                "
              >
                C
              </button>
              <button
                id="delete_button"
                (click)="
                  parentComponent.removeComponentFromGridster(
                    item,
                    parentComponent.selectedCustomTemplatesStaticUUID
                  )
                "
              >
                D
              </button>
              <app-dynamic-component
                [customComponent]="item"
                style="width: 100%; height: 100%"
              ></app-dynamic-component>
            </div>
          </gridster-item>
          }
        </gridster>
        } }
      </div>
    </div>
  </div>
</div>
